import React, { useLayoutEffect, useRef } from "react";
import { connect } from "react-redux";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import darkTheme from "@amcharts/amcharts4/themes/dark";
import { useTranslation } from "../../lang";
import { GetDateFormat } from "../../utils/generalUtils";

am4core.useTheme(darkTheme);
am4core.useTheme(am4themes_animated);

const ScoreChart = ({ data, user }) => {
  const [t] = useTranslation();
  const chart = useRef(null);

  //Ver diferencias entre useEffect y useLayoutEffect
  //useLayoutEffect se dispara de forma sincronica despues de las mutations del DOM
  useLayoutEffect(() => {
    if (chart.current) {
      chart.current.series.each((serie) => {
        serie.data = data;
      });
    }
  }, [data]);

  useLayoutEffect(() => {
    let x = am4core.create("scoreChartContainer", am4charts.XYChart);

    const title = x.titles.create();
    title.text = t("Puntaje Total");
    title.fontSize = 25;
    title.marginBottom = 30;
    title.align = "left";

    //Create axis
    x.xAxes.push(new am4charts.DateAxis());
    x.yAxes.push(new am4charts.ValueAxis());

    x.dateFormatter = new am4core.DateFormatter();
    x.dateFormatter.dateFormat = GetDateFormat(user.language, true);

    //Fleet Score serie
    let fleetScoreSerie = x.series.push(new am4charts.LineSeries());
    fleetScoreSerie.dataFields.valueY = "fleetScore";
    fleetScoreSerie.dataFields.dateX = "date";
    fleetScoreSerie.name = "FleetScore";
    fleetScoreSerie.tooltipText = `${t("Fecha")}: {dateX}
      ${t("Puntaje Flota")}: {valueY} [${t("Km/h")}]
    `;
    fleetScoreSerie.stroke = am4core.color("#A20F0F");
    fleetScoreSerie.strokeWidth = 2;
    /*const bulletFleet = fleetScoreSerie.bullets.push(new am4charts.CircleBullet());
    bulletFleet.circle.strokeWidth = 2;*/

    let segmentFS = fleetScoreSerie.segments.template;
    segmentFS.interactionsEnabled = true;

    fleetScoreSerie.data = data;

    //Driver or Asset serie
    let scoreSerie = x.series.push(new am4charts.LineSeries());
    scoreSerie.dataFields.valueY = "score";
    scoreSerie.dataFields.dateX = "date";
    scoreSerie.name = "Score";
    scoreSerie.stroke = am4core.color("#87C802");
    scoreSerie.strokeWidth = 2;
    scoreSerie.tooltipText = `${t("Fecha")}: {dateX}
    ${t("Puntaje")}: {valueY}
    `;

    let segmentScore = scoreSerie.segments.template;
    segmentScore.interactionsEnabled = true;

    scoreSerie.data = data;

    x.cursor = new am4charts.XYCursor();
    x.cursor.maxTooltipDistance = 0;

    chart.current = x;

    return () => {
      x.dispose();
    };
  }, [user.language]);

  return (
    <>
      <div id="scoreChartContainer" style={{ width: "100%", height: "40vh" }} />
    </>
  );
};

const _mapStateToProps = ({ user }) => {
  return {
    user,
  };
};

const _mapDispatchToProps = (dispatch) => {
  return {
    // _setCurrentUser: (param) => dispatch(setCurrentUser(param)),
  };
};

export default connect(_mapStateToProps, _mapDispatchToProps)(ScoreChart);
